import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable } from 'rxjs';
import { NewsResponse, SetNewsContentSeenResponse, SetNewsSeenFlagResponse } from '../state/news.models';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  getNews(language: string): Observable<NewsResponse> {
    const url = this.apiData.apiURL + `api/${this.client}/news/${language}`;
    return this.http.get<NewsResponse>(url);
  }

  setNewsSeenFlag(type: string): Observable<SetNewsSeenFlagResponse> {
    const url = this.apiData.apiURL + `api/${this.client}/news/${type}/seen`;
    return this.http.post<SetNewsSeenFlagResponse>(url, {});
  }

  setNewsContentSeen(id: number): Observable<SetNewsContentSeenResponse> {
    const url = this.apiData.apiURL + `api/${this.client}/news/content/${id}/seen`;
    return this.http.post<SetNewsContentSeenResponse>(url, {});
  }
}
